import "./MessagePreview.css";

const MessagePreview = ({
  channel = "whatsapp",
  imageUrl = "",
  text = "",
  sent = false,
  freeTextEnabled = false,
  onFreeTextToggle,
  onTextChange,
}) => (
  <div className={`message-wizard-preview message-wizard-preview--${channel}`} dir="rtl">
    <span className="message-wizard-preview__label">
      {sent ? "תצוגת ההודעה שנשלחה" : "תצוגה מקדימה"} — {channel === "whatsapp" ? "WhatsApp" : "SMS"}
    </span>
    {channel === "sms" && typeof onFreeTextToggle === "function" && (
      <label className="message-wizard-preview__free-toggle">
        <span>טקסט חופשי</span>
        <input
          type="checkbox"
          checked={freeTextEnabled}
          onChange={(event) => onFreeTextToggle(event.target.checked)}
        />
        <span className="message-wizard-preview__free-switch" aria-hidden="true" />
      </label>
    )}
    <div className="message-wizard-preview__bubble">
      {channel === "whatsapp" && imageUrl && <img src={imageUrl} alt="הזמנה" />}
      {channel === "sms" && freeTextEnabled && typeof onTextChange === "function" ? (
        <textarea
          className="message-wizard-preview__editor"
          value={text}
          onChange={(event) => onTextChange(event.target.value)}
          placeholder="חובה להזין טקסט חופשי"
          rows={6}
          aria-describedby="message-free-text-warning"
        />
      ) : (
        <p>{text}</p>
      )}
      {channel === "whatsapp" && (
        <span className="message-wizard-preview__time" dir="ltr">
          12:00 <b aria-label="הודעה נמסרה">✓✓</b>
        </span>
      )}
    </div>
    {channel === "sms" && freeTextEnabled && (
      <strong id="message-free-text-warning" className="message-wizard-preview__free-warning">
        מספרי שולחן / הסעה / תמונה / קישור להזמנה לא יישלחו
      </strong>
    )}
    {!(channel === "sms" && freeTextEnabled) && (
      <small>
        {sent
          ? "* הקישור, מספר השולחן ופרטי ההסעה הותאמו אישית לכל מוזמן בזמן השליחה."
          : "* הקישור, מספר השולחן ופרטי ההסעה יותאמו אישית לכל מוזמן בזמן השליחה."}
      </small>
    )}
  </div>
);

export default MessagePreview;
